import { BaseLogBloc } from "./bloc.base";

export class CloudLogBloc extends BaseLogBloc {

}